export default "/img/LoadingScreen.svg"